export default {
  /** 查询油罐信息列表 */
  selectYgInfoByList: '/ygsjzs/ygInfo/selectYgInfoByList',
  /** 查询油罐信息详情 */
  selectYgInfoByYgId: '/ygsjzs/ygInfo/selectYgInfoByYgId',
  /** 修改油罐信息 */
  updateYgInfo: '/ygsjzs/ygInfo/updateYgInfo',

  // 成品油管理
  // 查询用户库存列表
  selectYgUserInventoryByList: '/ygsjzs/ygUserInventory/selectYgUserInventoryByList',
  // 查询油罐库存详情
  selectYgUserInventoryByYgId: '/ygsjzs/ygUserInventory/selectYgUserInventoryByYgId',
  // 新增用户库存
  insertYgUserInventory: '/ygsjzs/ygUserInventory/insertYgUserInventory',
  // 修改用户库存
  updateYgUserInventory: '/ygsjzs/ygUserInventory/updateYgUserInventory',

  // 分页查询成品油类型
  selectYgOilTypeByPage: '/ygsjzs/ygOilType/selectYgOilTypeByPage',
  // 查询成品油类型详情
  selectYgOilTypeByOilType: '/ygsjzs/ygOilType/selectYgOilTypeByOilType',
  // 新增成品油类型
  insertYgOilType: '/ygsjzs/ygOilType/insertYgOilType',
  // 删除成品油类型
  deleteDataYgOilType: '/ygsjzs/ygOilType/deleteDataYgOilType',
  // 修改成品油类型/
  updateYgOilType: '/ygsjzs/ygOilType/updateYgOilType',
  // 删除库存
  deleteYgUserInventory: '/ygsjzs/ygUserInventory/deleteYgUserInventory'

}
